import React from 'react';
import AppNavbar from './components/AppNavbar';
import Checker from './components/Checker';

import { Container } from 'reactstrap';
import './App.css';

import ReactGA from 'react-ga';
ReactGA.initialize('UA-82155001-8');
ReactGA.pageview(window.location.pathname + window.location.search);

function App() {
  return (
    <div className="App">
        <AppNavbar />
        <Container> 
          {/* <h1 className="text-center">Tag Checker</h1> */}
          <h4 className="text-center">Third-party tag checker (JS and image)</h4>
        </Container>
        <Checker />
    </div>
  );
}

export default App;
